module.exports = __webpack_public_path__ + "static/media/ios-outlet.7b854849.svg";